/**
 * SupportPrivacyHint — persistent privacy disclaimer under the chat composer
 * of SupportWidget, plus its collapsible "Что мы собираем" details block.
 *
 * Extracted verbatim from SupportWidget.jsx (refactor, no behavior change).
 * Unlike SupportHowItWorks, the expand/collapse toggle stays a controlled
 * prop (not internal state): SupportWidget renders this hint every time
 * mode === 'chat' (not just on the empty state), so if the toggle owned its
 * own state it would reset on every chat<->form mode switch — a real
 * behavior change. Keeping it controlled preserves the exact pre-extraction
 * behavior (state persists in the parent across a mode switch).
 */
import { ShieldCheck } from 'lucide-react'

export default function SupportPrivacyHint({ expanded, onToggle }) {
    return (
        <>
            <div
                className="conversation__composer-hint"
                style={{ display: 'flex', alignItems: 'flex-start', gap: 6, padding: '0 14px 8px', textAlign: 'left' }}
            >
                <ShieldCheck size={12} style={{ flexShrink: 0, marginTop: 2 }} />
                <span>
                    Скриншоты могут содержать чужие данные — зарплаты и контакты закрашиваются автоматически.{' '}
                    <button
                        type="button"
                        onClick={onToggle}
                        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'var(--color-accent)', textDecoration: 'underline' }}
                    >
                        Что мы собираем
                    </button>
                </span>
            </div>
            {expanded && (
                <div className="text-xs text-muted" style={{ padding: '0 14px 10px', lineHeight: 1.5 }}>
                    Файлы хранятся 30 дней, доступны только администратору и автору обращения. Видео и голос
                    записываются по вашему действию; при записи экрана окно выбирается в системном диалоге браузера.
                    Крупное видео (до 500 МБ) загружается напрямую в защищённое хранилище.
                </div>
            )}
        </>
    )
}
